module.exports = __webpack_public_path__ + "img/securitization.7540d0f8.png";